import { Grid } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";
import AssignedTodoCard from "./AssignedTodoCard.jsx";

class UserTodosAssigned extends React.Component {
  render() {
    return (
      <Grid container>
        {this.props.todos.map(todo => {
          return (
            <GridItem
              xs={12}
              sm={12}
              md={6}
              style={{ marginBottom: "35px" }}
              key={todo.id}
            >
              <AssignedTodoCard
                title={todo.title}
                desc={todo.desc}
                date_created={todo.date_created}
                client_fullname={todo.client_fullname}
                doneToggle={() => this.props.handleDoneToggle(todo.id)}
                loadingAction={todo.loadingAction}
                from_user={todo.owner_fullname}
                due_date={todo.due_date}
              />
            </GridItem>
          );
        })}
      </Grid>
    );
  }
}

export default UserTodosAssigned;



// WEBPACK FOOTER //
// ./src/views/Todos/components/UserTodosAssigned.jsx